import { styled, useTheme, Select } from "@mui/material";

const StyledSelect = styled(Select)<{ noPointer?: boolean }>(({ theme, noPointer }) => ({
  pointerEvents: noPointer ? "none" : "auto",
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.surface.container,
  overflow: "hidden",
  width: "fit-content",

  ".MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(1.5),
    backgroundColor: theme.palette.surface.silver,
    pointerEvents: noPointer ? "none" : "auto",
    width: "100%",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${theme.palette.border.dark}`,
    borderRadius: theme.spacing(1.5),
  },

  "& .MuiSelect-icon": {
    color: theme.palette.text.secondary,
    fontSize: "24px",
  },

  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.border.dark}`,
    },
  },
}));

const BaseSelect = (props: any) => {
  const theme = useTheme();
  const { sx, children, ...rest } = props;
  return (
    <StyledSelect
      sx={{
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        minWidth: "fit-content",
        ...sx,
      }}
      MenuProps={{
        slotProps: {
          paper: {
            sx: {
              borderRadius: theme.spacing(1.5),
              backgroundColor: theme.palette.surface.silver,
              padding: theme.spacing(0.5, 2),
            },
          },
        },
      }}
      IconComponent={undefined}
      {...rest}>
      {children}
    </StyledSelect>
  );
};

export default BaseSelect;
